import { render } from "./CustomFieldList.vue?vue&type=template&id=6886451c"
import script from "./CustomFieldList.vue?vue&type=script&lang=js"
export * from "./CustomFieldList.vue?vue&type=script&lang=js"

import "./CustomFieldList.vue?vue&type=style&index=0&id=6886451c&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__